import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import logoIcon from "@/assets/logo-warmzapp.webp";

const TermsOfUse = () => (
  <div className="min-h-screen bg-background text-foreground">
    <header className="border-b border-border py-4">
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-1 font-display text-xl font-bold">
          <img src={logoIcon} alt="WarmZapp" className="h-9 w-auto" />
          Warm<span className="text-primary">Zapp</span>
        </Link>
        <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Voltar
        </Link>
      </div>
    </header>

    <main className="container mx-auto px-4 md:px-8 py-12 max-w-3xl space-y-8">
      <h1 className="font-display text-3xl md:text-4xl font-bold">Termos de Uso</h1>
      <p className="text-muted-foreground">Última atualização: 2 de março de 2026</p>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">1. Aceitação dos Termos</h2>
        <p className="text-muted-foreground leading-relaxed">
          Ao acessar ou utilizar a plataforma WarmZapp, você concorda em cumprir estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não utilize nossos serviços.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">2. Descrição do Serviço</h2>
        <p className="text-muted-foreground leading-relaxed">
          O WarmZapp é uma plataforma de aquecimento de chips WhatsApp e gerenciamento de disparos em massa. Fornecemos ferramentas para aquecer números, gerenciar instâncias e monitorar a saúde dos seus chips.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">3. Conta do Usuário</h2>
        <p className="text-muted-foreground leading-relaxed">
          Você é responsável por manter a confidencialidade de suas credenciais de acesso. Todas as atividades realizadas em sua conta são de sua responsabilidade. Notifique-nos imediatamente sobre qualquer uso não autorizado.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">4. Uso Aceitável</h2>
        <p className="text-muted-foreground leading-relaxed">
          Você concorda em utilizar a plataforma apenas para fins legais e em conformidade com todas as leis aplicáveis. É proibido utilizar o serviço para envio de spam, conteúdo ilegal, assédio ou qualquer atividade que viole os termos de serviço do WhatsApp.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">5. Pagamentos e Assinaturas</h2>
        <p className="text-muted-foreground leading-relaxed">
          Os planos são cobrados de forma recorrente conforme o ciclo escolhido. Cancelamentos podem ser feitos a qualquer momento, com efeito ao final do período vigente. Não realizamos reembolsos proporcionais.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">6. Limitação de Responsabilidade</h2>
        <p className="text-muted-foreground leading-relaxed">
          O WarmZapp não se responsabiliza por banimentos de números pelo WhatsApp, perdas de dados ou interrupções de serviço. Utilizamos nossos melhores esforços para garantir a qualidade, mas o serviço é fornecido "como está".
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">7. Propriedade Intelectual</h2>
        <p className="text-muted-foreground leading-relaxed">
          Todo o conteúdo, design, código e funcionalidades da plataforma são de propriedade exclusiva do WarmZapp. É proibida a reprodução, distribuição ou modificação sem autorização prévia por escrito.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">8. Alterações nos Termos</h2>
        <p className="text-muted-foreground leading-relaxed">
          Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações significativas serão comunicadas por e-mail ou notificação na plataforma. O uso continuado após alterações constitui aceitação dos novos termos.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">9. Contato</h2>
        <p className="text-muted-foreground leading-relaxed">
          Para dúvidas sobre estes Termos de Uso, entre em contato pelo e-mail suporte@warmzapp.com.
        </p>
      </section>
    </main>
  </div>
);

export default TermsOfUse;
